import Table from '@components/elements/Table';
import { createColumnHelper } from '@tanstack/react-table';
import { T } from 'react-translator-component';

export type RowsProp = {
  period: number;
  minAmount: number;
  rate: number;
}

interface TableProps {
  rows: any,
  onClickRow: (minAmount: number) => void,
}

const columnHelper = createColumnHelper<RowsProp>();

const TermTable: React.FC<TableProps> = ({ rows, onClickRow }) => {
  const columns = [
    columnHelper.accessor(row => row.period, {
      id: 'period',
      header: () => <span>{T('Term Period')}</span>,
      cell: info => <span className='cursor-pointer' onClick={() => { onClickRow(info.row.original.minAmount); }}>
        {info.getValue()} {T('Days')}</span>
    }),
    columnHelper.accessor(row => row.minAmount, {
      id: 'minAmount',
      header: () => <span>{T('Minimum Deposit (TIFI)')}</span>,
      cell: info => <span className='cursor-pointer' onClick={() => { onClickRow(info.row.original.minAmount); }}>
        {info.getValue().toLocaleString()}</span>
    }),
    columnHelper.accessor(row => row.rate, {
      id: 'rate',
      header: () => <span>{T('APR')}</span>,
      cell: info => <span className='cursor-pointer' onClick={() => { onClickRow(info.row.original.minAmount); }}>
        {info.getValue() * 100} %</span>
    }),
  ];

  return <div>
    {rows?.length >= 1 && <Table columns={columns} data={rows} title={`${T('Earning Terms (Click one row to start)')}`} />}
  </div>;
}

export default TermTable;